import React, { useState, useEffect } from "react";
import Avatar from "../Form/Avatar";
import UserInfo from "../Form/UserInfo";
import Logo from "../../assets/logo.svg";

export default function TopBar({ title, user }) {
  // const [setShowUserSidebar] = useState(false);

  // // Auto-close sidebar if resizing to >=sm
  // useEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth >= 640) {
  //       setShowUserSidebar(false);
  //     }
  //   };
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  return (
    <>
      <div className="flex items-center justify-between w-full h-[4.9375rem] px-2 md:px-[100px]  lg:px-[226px]  bg-white drop-shadow-[0_5px_5px_rgba(0,0,0,0.05)]">
        <h1 className="ml-3 lg:-ml-10 font-bold text-transparent text-level-5 sm:text-level-4 md:text-level-3 xl:text-level-2 font-alexandria bg-main-header-gradient bg-clip-text ">
          {title}
        </h1>
        <div className="flex items-center gap-4 mr-5 md:mr-0">
          <div className="w-10 h-10 md:w-12 md:h-12 cursor-default focus:outline-none">
            <Avatar
              profilePicture={user.profilePicture}
              userName={user.name}
              size={48}
            />
          </div>
          <div className="flex-col">
            <UserInfo userName={user.name} />
          </div>
        </div>
      </div>
    </>
  );
}
